import { render } from "./RevisarNotas.vue?vue&type=template&id=0dcb803c"
import script from "./RevisarNotas.vue?vue&type=script&lang=js"
export * from "./RevisarNotas.vue?vue&type=script&lang=js"

import "./RevisarNotas.vue?vue&type=style&index=0&id=0dcb803c&lang=css"

import exportComponent from "C:\\Users\\User\\Documents\\PROJETOS - LEFISC\\front_revisor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__